<main class="content">
  <section class="intro">
    <h1 class="font-extrabold"><span paint="warn">Get access to unlimited and higher discounts</span></h1>
    <p paint="light" class="font-light">Find 1000+ offers on fashion, food & more.</p>
    <p paint="light" class="font-light">Get access to 2 for 1 offers and discounts of up to 50% OFF!</p>
    <h3><span paint="warn">How to get Premium</span></h3>
  </section>

  <section class="guide">
    <div>
      <div class="orb" paint="accent">
        <span></span>
        <h1 class="font-extrabold">1</h1>
      </div>
      <p paint="light" class="font-light">Click on <span bold>‘Premium’</span> in the bottom right corner.
      </p>
      <img src="old/how-tos/premium-icon.webp" alt="Step 1" />
    </div>
    <div>
      <div class="orb" paint="primary">
        <span></span>
        <h1 class="font-extrabold">2</h1>
      </div>
      <p paint="light" class="font-light">Choose a plan - either pay <span bold>yearly</span> or pay <span bold>monthly</span> and get access to all the orange offers.
      </p>
      <img src="old/how-tos/choose-plan.webp" alt="Step 2" />
    </div>
    <div>
      <div class="orb" paint="warn">
        <span></span>
        <h1 class="font-extrabold">3</h1>
      </div>
      <p paint="light" class="font-light">
        During checkout, insert a discount code if you have one. Click <span bold>‘Next’</span> and proceed to payment.
      </p>
      <img src="old/how-tos/checkout.webp" alt="Step 3" />
    </div>
  </section>

  <section class="outro">
    <p paint="light" class="font-light">For more information, please send us an email on <a href="mailto:support@cloudigo.app"
        paint="primary">support&#64;cloudigo.app</a> or talk to us on <a target="_top" rel="noreferrer" href="https://www.facebook.com/cloudigo"
        paint="primary">Facebook</a>.</p>

    <a mat-flat-button class="premium-horizontal" routerLink="/premium">Get Premium Now</a>

  </section>
</main>